/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Reason_Conservative_StartInputs */

const en_us2_prescription_reason_conservative_start = /** @type {(inputs: Prescription_Reason_Conservative_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting gently for four weeks, as your health answers suggest`)
};

const pt_br2_prescription_reason_conservative_start = /** @type {(inputs: Prescription_Reason_Conservative_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começando com calma por quatro semanas, como suas respostas de saúde sugerem`)
};

const es_419_prescription_reason_conservative_start = /** @type {(inputs: Prescription_Reason_Conservative_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezando con calma por cuatro semanas, como sugieren tus respuestas de salud`)
};

const pt_pt2_prescription_reason_conservative_start = /** @type {(inputs: Prescription_Reason_Conservative_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A começar com calma durante quatro semanas, como sugerem as tuas respostas de saúde`)
};

const fr_fr2_prescription_reason_conservative_start = /** @type {(inputs: Prescription_Reason_Conservative_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage en douceur pendant quatre semaines, comme le suggèrent tes réponses de santé`)
};

const de_de2_prescription_reason_conservative_start = /** @type {(inputs: Prescription_Reason_Conservative_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vier Wochen sanfter Start, wie deine Gesundheitsantworten nahelegen`)
};

const it_it2_prescription_reason_conservative_start = /** @type {(inputs: Prescription_Reason_Conservative_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio graduale per quattro settimane, come suggeriscono le tue risposte sulla salute`)
};

/**
* | output |
* | --- |
* | "Starting gently for four weeks, as your health answers suggest" |
*
* @param {Prescription_Reason_Conservative_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_conservative_start = /** @type {((inputs?: Prescription_Reason_Conservative_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Conservative_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_conservative_start(inputs)
	if (locale === "es-419") return es_419_prescription_reason_conservative_start(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_conservative_start(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_conservative_start(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_conservative_start(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_conservative_start(inputs)
	return en_us2_prescription_reason_conservative_start(inputs)
});
export { prescription_reason_conservative_start as "prescription.reason.conservative_start" }